/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  // Sales Channels
  document.addEventListener("DOMContentLoaded", () => {
    var modal = document.getElementById("product-channels-modal");
    if (modal !== null) {
      var btns = document.querySelectorAll(".product-channels-header-btn");
      var productBtn = document.getElementById("product-channels-btn");
      var anchorBtn = document.querySelector('a[href="#where-to-buy"]');
      var closeBtn = document.getElementById("modal-content-close");

      function openModal() {
        modal.classList.add("modal-open");
        document.body.classList.add("modal-open");
      }

      function closeModal() {
        modal.classList.remove("modal-open");
        document.body.classList.remove("modal-open");
      }

      if (btns.length > 0) {
        btns.forEach(btn => {
          btn.addEventListener("click", openModal);
        });
      }

      if (productBtn !== null) {
        productBtn.onclick = openModal;
      }

      if (anchorBtn !== null) {
        anchorBtn.onclick = openModal;
      }

      if (closeBtn !== null) {
        closeBtn.onclick = closeModal;
      }

      window.onclick = function (event) {
        if (modal && event.target === modal) {
          closeModal();
        }
      };
    }
  });
  
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href="#trustarc_cookie_settings"]');
    if (!link) return;
    e.preventDefault();
    if (window.truste && window.truste.eu && window.truste.eu.clickListener) {
      window.truste.eu.clickListener();
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
